import { Box, BoxProps, Flex, Icon, TextProps } from "@chakra-ui/react";

import { BiAlarm } from "react-icons/bi";
import { FiChevronDown } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";
import {NavMenuItem, subMenuItem} from "@/types/creatorcenter";
import useActive from "./hooks/useActive";
import useExpand from "./hooks/useExpand";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch } from "@/store/hooks";

type Props ={
  MenuList: NavMenuItem[];
}

const activeClass: TextProps = {
  color: "#27314D",
  fontWeight: "semibold",
  bgColor: "rgba(238, 241, 247, 0.5);"
};

const unActiveClass: TextProps = {
  color: "gray.500",
  fontWeight: "400",
};

const menuItemClass: BoxProps = {
  p: "15px",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.2s",
  fontSize: "14px",
  _hover: {
    bg: "gray.50",
  },
};

const NavMenu = (props:Props) => {
  const {MenuList} = props;
  const navigate = useNavigate();
  const { activatedMenu, setMenuActive } = useActive();
  const { isExpanded, setMenuExpand } = useExpand();

  const location = useLocation();
  const dispatch = useAppDispatch();
  const currentUrl = location.pathname;

  useEffect(()=>{
    MenuList.map((item, index)=> {
      if(item.subMenu){
        item.subMenu.map((sub, subindex) =>{
          if(sub.path === currentUrl){
            setMenuExpand(index);
            setMenuActive(index, subindex)
          }
        })
      }else{
        if(item.path === currentUrl ){
          setMenuActive(index);
        }
      }
    })

    // if (MenuList[0].subMenu) {
    //   setMenuExpand(0);
    //   setMenuActive(0, 0)
    // } else {
    //   setMenuActive(0);
    // }
  },[])

  const onMenuClick = (index: number, item: NavMenuItem) => {
    if (item.subMenu) {
      setMenuExpand(index);
    } else {
      setMenuActive(index);
      if(item.path){
        navigate(item.path);
      }
      
    }
  };

  const onMenuSubClick = (index: number,subIndex:number, item: subMenuItem) => {
    setMenuActive(index, subIndex);
    navigate(item.path);
  }

  return (
    <Box
      w="200px"
      h="100%"
      // boxShadow="lg"
      position="relative"
      transition="width 0.2s"
    >
      {MenuList.map((menuItem, index) => {
        return (
          <Box key={menuItem.title}>
            <Flex
              align="center"
              justify="space-between"
              {...menuItemClass}
              {...(activatedMenu[0] === index ? activeClass : unActiveClass)}
              onClick={() => {
                onMenuClick(index, menuItem);
              }}
            >
              <Flex align="center" overflow="hidden">
                <Box mr="14px">{menuItem.icon}</Box>
                <Box fontSize="14px">{menuItem.title}</Box>
              </Flex>

              {menuItem.subMenu && (
                <Icon
                  transition="transform 0.2s ease-in-out"
                  transform={`rotate(${isExpanded(index) ? -180 : 0}deg)`}
                  as={FiChevronDown}
                />
              )}
            </Flex>
            <AnimatePresence>
              {isExpanded(index) && (
                <motion.div
                  style={{ overflow: "hidden" }}
                  initial={{ height: "0px", opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: "0px", opacity: 0 }}
                  transition={{ duration: 0.2, ease: "easeInOut" }}
                >
                  {menuItem.subMenu?.map((subMenuItem, subIndex) => {
                    return (
                      <Box
                        {...menuItemClass}
                        {...(activatedMenu[1] === subIndex
                          ? activeClass
                          : unActiveClass)}
                        pl="45px"
                        key={subMenuItem.title}
                        onClick={() => onMenuSubClick(index, subIndex, subMenuItem) }
                      >
                        {subMenuItem.title}
                      </Box>
                    );
                  })}
                </motion.div>
              )}
            </AnimatePresence>
          </Box>
        );
      })}
    </Box>
  );
};

export default NavMenu;
